<button #alertTrigger (onMenuOpen)="menuOpened()" [disabled]="!hasAlerts" [matMenuTriggerFor]="toolbarAlertMenu"
  [ngClass]="alertTriggerBtn && alertTriggerBtn.menuOpen || !hasAlerts?'':'pulse'" color="accent" mat-icon-button>
  <mat-icon fontIcon="fa-chart-pie" fontSet="fa-solid" style="font-size:22px;"></mat-icon>
  @if (alertCount>0 && alertCount < 10) {
    <span
    style="color: white; position: absolute; left: 21px; font-size: 14px; padding-top: 2px;">{{ alertCount }}</span>
  }
  @if (alertCount>=10 ) {
    <span style="color: white; position: absolute; left: 16px; font-size: 12px;">{{ alertCount
    }}</span>
  }
</button>

<mat-menu #toolbarAlertMenu="matMenu" class="padded-menu" xPosition="before">
  @if (!alertData) {
    <p>Loading...</p>
  }
  @if (alertData) {
    @for (problemDay of alertData.dates; track problemDay) {
      <div>
        <div class="date-separator">
          {{
          problemDay.date | amCalendar:{
          sameDay: '[Today]',
          nextDay: '[Tomorrow]',
          nextWeek: 'dddd',
          lastDay: '[Yesterday]',
          lastWeek: '[Last] dddd',
          sameElse: 'DD/MM/YYYY'
        }
        }}
        <span class="spacer"></span> {{ problemDay.totalAlerts }} Issue{{ problemDay.totalAlerts > 1 ? 's' : '' }}
      </div>
      @if (problemDay.resourceAvailabilities) {
        @for (resourceAvailability of problemDay.resourceAvailabilities; track resourceAvailability) {
          <div (click)="openResourceAvailabilityDialog(resourceAvailability.availabilityId)" class="alert-menu-widget">
            @if (resourceAvailability.availability) {
              <div>
                <div style="padding:3px;"><span>
                {{ resourceAvailability.availability.resource.name }} </span> <br />
                <span>
                  {{ resourceAvailability.availability.start | amDateFormat : 'HH:mm' }}
                  -
                  {{ resourceAvailability.availability.end | amDateFormat : 'HH:mm' }}
                </span>
              </div>
              <!--              <br/>-->
              <!--              -->
              <!--              Normal/High/Emergency Reservations:-->
              <!--              <span *ngIf="resourceAvailability.availability.normalPriorityReservationPercent">-->
              <!--              {{resourceAvailability.availability.normalPriorityReservationPercent}}%-->
            <!--            </span>-->
            <!--              <span *ngIf="resourceAvailability.availability.normalPriorityReservationDuration">-->
            <!--              {{resourceAvailability.availability.normalPriorityReservationDuration / 60}} mins-->
          <!--            </span>-->
          <!--              <span-->
        <!--                *ngIf="!resourceAvailability.availability.normalPriorityReservationPercent && !resourceAvailability.availability.normalPriorityReservationDuration">Off</span>-->
        <!--              /-->
        <!--              <span *ngIf="resourceAvailability.availability.highPriorityReservationPercent">-->
        <!--              {{resourceAvailability.availability.highPriorityReservationPercent}}%-->
      <!--            </span>-->
      <!--              <span *ngIf="resourceAvailability.availability.highPriorityReservationDuration">-->
      <!--              {{resourceAvailability.availability.highPriorityReservationDuration / 60}} mins-->
    <!--            </span>-->
    <!--              <span-->
  <!--                *ngIf="!resourceAvailability.availability.highPriorityReservationPercent && !resourceAvailability.availability.highPriorityReservationDuration">Off</span>-->
  <!--              /-->
  <!--              <span *ngIf="resourceAvailability.availability.emergencyPriorityReservationPercent">-->
  <!--              {{resourceAvailability.availability.emergencyPriorityReservationPercent}}%-->
<!--            </span>-->
<!--              <span *ngIf="resourceAvailability.availability.emergencyPriorityReservationDuration">-->
<!--              {{resourceAvailability.availability.emergencyPriorityReservationDuration / 60}} mins-->
<!--            </span>-->
<!--              <span-->
<!--                *ngIf="!resourceAvailability.availability.emergencyPriorityReservationPercent && !resourceAvailability.availability.emergencyPriorityReservationDuration">Off</span>-->
<mat-chip-set aria-label="Resource Overage" class="mat-chip-set-stacked">
  @if (resourceAvailability.normalOver) {
    <mat-chip [style.background-color]="'orange'"
      [matTooltip]="resourceAvailability.availability.normalPriorityReservationPercent + '%'">
      Normal Reservation Exceeded
    </mat-chip>
  }
  @if (resourceAvailability.highOver) {
    <mat-chip [style.background-color]="'darkorange'"
      [matTooltip]="resourceAvailability.availability.highPriorityReservationPercent + '%'">
      High Reservation Exceeded
    </mat-chip>
  }
  @if (resourceAvailability.emergencyOver) {
    <mat-chip [style.background-color]="'red'"
      [matTooltip]="resourceAvailability.availability.emergencyPriorityReservationPercent + '%'">
      Emergency Reservation Exceeded
    </mat-chip>
  }
</mat-chip-set>
<!--              <ul>-->
<!--                <li *ngFor="let issue of resourceAvailability.issues">{{issue}}</li>-->
<!--              </ul>-->
</div>
}
@if (!resourceAvailability.availability) {
  <div>
    Loading..
  </div>
}
</div>
}
}
</div>
}
}

</mat-menu>
